import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import ruleSectionsReducer from './ruleSectionsSlice';
import itemReducer from './itemReducer';
import userReducer from './userSlice';

const rootReducer = combineReducers({
  ruleSections: ruleSectionsReducer,
  item: itemReducer,
  user: userReducer,
});

const persistConfig = {
  key: 'root',
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default persistedReducer;